import { useState } from "react";
import {
    ShoppingBag,
    Package,
    ChevronDown,
} from "lucide-react";

import "./CartPreview.css";
import { Link } from "react-router-dom";
export default function CartPreview({
    cart = [],
}) {

    const [isOpen, setIsOpen] = useState(false);


    const getImage = (item) => {
     

        const images = item?.images;

        return (
            (Array.isArray(images) ? images[0]?.url || images[0]?.src || images[0]?.path : null) ||
            null
        );
    };


    const getName = (item) => {
        return (
            item.name ||
            item.productName ||
            item.product?.name ||
            "محصول"
        );
    };


    const getOriginalPrice = (item) => {
        return Number(
            item.selectedVariation.price ??
            0
        );
    };

    const getFinalPrice = (item) => {
        return Number(
            item.selectedVariation?.finalPrice ??
            0
        );
    };


    const getQuantity = (item) => {
        return Number(
            item.quantity ??
            item.qty ??
            1
        );
    };


    const totalItems = cart.reduce(
        (total, item) =>
            total + getQuantity(item),
        0
    );


    return (
        <section
            className={`cart-preview ${isOpen ? "open" : "closed"
                }`}
            dir="rtl"
        >

            {/* =========================================
                HEADER
            ========================================= */}

            <button
                type="button"
                className="cart-preview-toggle"
                onClick={() =>
                    setIsOpen((previous) => !previous)
                }
                aria-expanded={isOpen}
            >

                <div className="cart-preview-toggle-left">

                    <div className="cart-preview-icon">

                        <ShoppingBag size={20} />

                    </div>


                    <div className="cart-preview-heading">

                        <h3>
                           محصولات سفارش
                        </h3>

                        <span>
                            {totalItems} محصول
                        </span>

                    </div>

                </div>


                <ChevronDown
                    size={22}
                    className={`cart-preview-chevron ${isOpen ? "rotated" : ""
                        }`}
                />

            </button>


            {/* =========================================
                CONTENT
            ========================================= */}

            <div
                className={`cart-preview-wrapper ${isOpen ? "visible" : ""
                    }`}
            >

                <div className="cart-preview-inner">

                    {!cart.length ? (

                        <div className="cart-preview-empty">

                            <Package size={28} />

                            <span>
                                سبد خرید خالی است
                            </span>

                        </div>

                    ) : (

                        <div className="cart-preview-list">

                            {cart.map((item, index) => {

                                const originalPrice =
                                    getOriginalPrice(item);

                                const finalPrice =
                                    getFinalPrice(item);

                                const quantity =
                                    getQuantity(item);

                                const hasDiscount =
                                    originalPrice >
                                    finalPrice;


                                return (
                                    <article
                                        className="cart-preview-item"
                                        key={
                                            item.id ??
                                            item.selectedVariation?.id ??
                                            index
                                        }
                                    >

                                        {/* LEFT COLUMN */}

                                        <div className="cart-product-column">

                                            <div className="cart-product-image">
                                                <Link to={`/product/${item?.slug || item?.id}`}
                                                    className="mini-cart-item__image"
                                                    aria-label={`مشاهده ${item.name}`}
                                                >
                                                    <img
                                                        src={getImage(item)}
                                                        alt={getName(item)}
                                                    />
                                                </Link>


                                            </div>


                                            <div className="cart-product-info">

                                                <h4>
                                                    {getName(item)}
                                                </h4>


                                                {item
                                                    .selectedVariation
                                                    ?.title && (

                                                        <span className="cart-variation">

                                                            {
                                                                item
                                                                    .selectedVariation
                                                                    .title
                                                            }

                                                        </span>

                                                    )}

                                            </div>

                                        </div>


                                        {/* RIGHT COLUMN */}

                                        <div className="cart-price-column">

                                            <div className="cart-price-block">

                                                {hasDiscount && (

                                                    <span className="cart-original-price">

                                                        {originalPrice.toLocaleString(
                                                            "fa-IR"
                                                        )}{" "}
                                                        تومان

                                                    </span>

                                                )}


                                                <strong className="cart-final-price">

                                                    {finalPrice.toLocaleString(
                                                        "fa-IR"
                                                    )}{" "}
                                                    تومان

                                                </strong>

                                            </div>


                                            <div className="cart-quantity">

                                                تعداد:
                                                {" "}

                                                <strong>
                                                    {quantity}
                                                </strong>

                                            </div>

                                        </div>

                                    </article>
                                );

                            })}

                        </div>

                    )}

                </div>

            </div>

        </section>
    );
}